import React from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-container">
        <h1>POLITIQUE DE CONFIDENTIALITÉ</h1>
        <h2>Smart Delivery Gabon</h2>
        
        <div className="last-updated">
          <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
        </div>

        <section>
          <h2>1. INTRODUCTION</h2>
          <p>
            Smart Delivery Gabon ("nous", "notre", "l'application") s'engage à protéger la confidentialité et la sécurité des informations personnelles de ses utilisateurs. Cette politique de confidentialité explique comment nous collectons, utilisons, stockons et protégeons vos données personnelles lorsque vous utilisez notre application mobile de livraison de colis.
          </p>
          <p>
            En utilisant l'application Smart Delivery Gabon, vous acceptez les pratiques décrites dans cette politique de confidentialité. Si vous n'acceptez pas cette politique, veuillez ne pas utiliser notre application.
          </p>
        </section>

        <section>
          <h2>2. INFORMATIONS QUE NOUS COLLECTONS</h2>
          
          <h3>2.1. Informations que vous nous fournissez directement</h3>
          <p>Lors de l'utilisation de notre application, nous collectons les informations suivantes :</p>
          
          <p><strong>Informations d'identification :</strong></p>
          <ul>
            <li>Numéro de téléphone (pour la connexion et l'authentification)</li>
            <li>Nom complet (si fourni)</li>
            <li>Adresse email (pour les comptes administrateurs uniquement)</li>
          </ul>
          
          <p><strong>Informations relatives aux colis :</strong></p>
          <ul>
            <li>Nom de l'expéditeur</li>
            <li>Numéro de téléphone de l'expéditeur</li>
            <li>Nom du destinataire</li>
            <li>Numéro de téléphone du destinataire</li>
            <li>Adresse de ramassage</li>
            <li>Adresse de destination</li>
            <li>Type de colis (Documents, Petit colis, etc.)</li>
            <li>Type de livraison (Livraison express 30min à 2h ou Livraison standard 2H à 6h)</li>
            <li>Numéro de suivi unique</li>
            <li>Coût de la livraison</li>
            <li>Statut de la livraison</li>
          </ul>
          
          <h3>2.2. Informations collectées automatiquement</h3>
          <p><strong>Données d'utilisation :</strong></p>
          <ul>
            <li>Historique des commandes</li>
            <li>Dates et heures de création et de mise à jour des colis</li>
            <li>Interactions avec l'application</li>
          </ul>
          
          <p><strong>Données techniques :</strong></p>
          <ul>
            <li>Informations sur votre appareil (type, modèle, système d'exploitation)</li>
            <li>Adresse IP</li>
            <li>Identifiants uniques de l'appareil</li>
          </ul>
          
          <h3>2.3. Permissions de l'application</h3>
          <p>Notre application demande les permissions suivantes :</p>
          <ul>
            <li><strong>INTERNET</strong> : Nécessaire pour la communication avec nos serveurs</li>
            <li><strong>ACCESS_NETWORK_STATE</strong> : Pour vérifier la connectivité réseau</li>
            <li><strong>READ_PHONE_STATE</strong> : Pour identifier votre appareil de manière unique</li>
            <li><strong>CALL_PHONE</strong> : Pour permettre l'appel direct depuis l'application (optionnel)</li>
          </ul>
        </section>

        <section>
          <h2>3. UTILISATION DES INFORMATIONS</h2>
          <p>Nous utilisons les informations collectées pour les finalités suivantes :</p>
          
          <h3>3.1. Fourniture du service</h3>
          <ul>
            <li>Traiter et gérer vos commandes de livraison</li>
            <li>Générer et attribuer des numéros de suivi uniques</li>
            <li>Suivre l'état de vos colis en temps réel</li>
            <li>Faciliter la communication entre expéditeurs, destinataires et livreurs</li>
            <li>Envoyer des notifications concernant vos livraisons</li>
          </ul>
          
          <h3>3.2. Communication</h3>
          <ul>
            <li>Vous contacter concernant vos commandes</li>
            <li>Envoyer des notifications par WhatsApp (si configuré)</li>
            <li>Répondre à vos demandes et questions</li>
            <li>Vous informer des mises à jour importantes concernant nos services</li>
          </ul>
          
          <h3>3.3. Amélioration du service</h3>
          <ul>
            <li>Analyser l'utilisation de l'application pour améliorer nos services</li>
            <li>Développer de nouvelles fonctionnalités</li>
            <li>Résoudre les problèmes techniques</li>
            <li>Assurer la sécurité et prévenir la fraude</li>
          </ul>
          
          <h3>3.4. Conformité légale</h3>
          <ul>
            <li>Respecter nos obligations légales</li>
            <li>Répondre aux demandes des autorités compétentes</li>
            <li>Protéger nos droits et ceux de nos utilisateurs</li>
          </ul>
        </section>

        <section>
          <h2>4. PARTAGE DES INFORMATIONS</h2>
          <p>Nous ne vendons jamais vos informations personnelles à des tiers. Nous pouvons partager vos informations dans les cas suivants :</p>
          
          <h3>4.1. Prestataires de services</h3>
          <p>Nous pouvons partager vos informations avec des prestataires de services tiers qui nous aident à exploiter notre application, notamment :</p>
          <ul>
            <li><strong>Supabase</strong> : Hébergement et gestion de la base de données</li>
            <li><strong>Whapi</strong> : Service de notifications WhatsApp (si activé)</li>
            <li>Prestataires d'hébergement et d'infrastructure cloud</li>
          </ul>
          <p>Ces prestataires sont contractuellement tenus de protéger vos informations et de ne les utiliser que pour les finalités pour lesquelles nous les leur avons communiquées.</p>
          
          <h3>4.2. Livreurs et partenaires de livraison</h3>
          <p>Nous partageons les informations nécessaires (nom, numéro de téléphone, adresse) avec nos livreurs et partenaires de livraison pour permettre l'exécution de vos commandes.</p>
          
          <h3>4.3. Obligations légales</h3>
          <p>Nous pouvons divulguer vos informations si la loi l'exige ou si nous pensons de bonne foi qu'une telle divulgation est nécessaire pour :</p>
          <ul>
            <li>Se conformer à une obligation légale</li>
            <li>Protéger et défendre nos droits ou notre propriété</li>
            <li>Prévenir ou enquêter sur d'éventuelles infractions</li>
            <li>Protéger la sécurité personnelle des utilisateurs de l'application ou du public</li>
          </ul>
        </section>

        <section>
          <h2>5. STOCKAGE ET SÉCURITÉ DES DONNÉES</h2>
          
          <h3>5.1. Stockage des données</h3>
          <p>Vos données sont stockées sur des serveurs sécurisés gérés par Supabase, situés dans des centres de données conformes aux normes de sécurité internationales. Nous conservons vos données personnelles aussi longtemps que nécessaire pour fournir nos services et respecter nos obligations légales.</p>
          
          <h3>5.2. Sécurité</h3>
          <p>Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations personnelles contre :</p>
          <ul>
            <li>L'accès non autorisé</li>
            <li>La perte ou la destruction accidentelle</li>
            <li>La divulgation non autorisée</li>
            <li>La modification non autorisée</li>
          </ul>
          
          <p>Ces mesures incluent :</p>
          <ul>
            <li>Chiffrement des données en transit et au repos</li>
            <li>Authentification sécurisée</li>
            <li>Contrôles d'accès stricts</li>
            <li>Surveillance et détection des intrusions</li>
            <li>Sauvegardes régulières</li>
          </ul>
          
          <div className="highlight">
            <p><strong>Note importante :</strong> Aucune méthode de transmission sur Internet ou de stockage électronique n'est totalement sécurisée. Bien que nous nous efforcions d'utiliser des moyens commercialement acceptables pour protéger vos informations, nous ne pouvons garantir leur sécurité absolue.</p>
          </div>
        </section>

        <section>
          <h2>6. VOS DROITS</h2>
          <p>Conformément aux lois applicables sur la protection des données, vous disposez des droits suivants :</p>
          
          <h3>6.1. Droit d'accès</h3>
          <p>Vous avez le droit d'accéder aux informations personnelles que nous détenons sur vous.</p>
          
          <h3>6.2. Droit de rectification</h3>
          <p>Vous pouvez demander la correction de toute information inexacte ou incomplète.</p>
          
          <h3>6.3. Droit à l'effacement</h3>
          <p>Vous pouvez demander la suppression de vos informations personnelles, sous réserve de certaines limitations légales.</p>
          
          <h3>6.4. Droit d'opposition</h3>
          <p>Vous pouvez vous opposer au traitement de vos données personnelles dans certaines circonstances.</p>
          
          <h3>6.5. Droit à la portabilité</h3>
          <p>Vous pouvez demander à recevoir vos données dans un format structuré et couramment utilisé.</p>
          
          <h3>6.6. Exercice de vos droits</h3>
          <p>Pour exercer l'un de ces droits, veuillez nous contacter à l'adresse indiquée dans la section "Contact" ci-dessous. Nous répondrons à votre demande dans un délai raisonnable et conformément à la législation applicable.</p>
        </section>

        <section>
          <h2>7. CONSENTEMENT ET RETRAIT DU CONSENTEMENT</h2>
          <p>En utilisant notre application, vous consentez à la collecte et à l'utilisation de vos informations conformément à cette politique de confidentialité.</p>
          <p>Vous pouvez retirer votre consentement à tout moment en :</p>
          <ul>
            <li>Supprimant votre compte (si cette fonctionnalité est disponible)</li>
            <li>Nous contactant directement pour demander la suppression de vos données</li>
            <li>Désinstallant l'application</li>
          </ul>
          <p>Le retrait de votre consentement peut affecter votre capacité à utiliser certaines fonctionnalités de l'application.</p>
        </section>

        <section>
          <h2>8. DONNÉES DES ENFANTS</h2>
          <p>Notre application n'est pas destinée aux personnes de moins de 18 ans. Nous ne collectons pas sciemment d'informations personnelles d'enfants. Si nous apprenons qu'un enfant nous a fourni des informations personnelles, nous prendrons des mesures pour supprimer ces informations de nos systèmes.</p>
        </section>

        <section>
          <h2>9. COOKIES ET TECHNOLOGIES SIMILAIRES</h2>
          <p>Notre application peut utiliser des technologies similaires aux cookies pour améliorer votre expérience, analyser l'utilisation de l'application et personnaliser le contenu. Vous pouvez contrôler ces technologies via les paramètres de votre appareil.</p>
        </section>

        <section>
          <h2>10. TRANSFERT INTERNATIONAL DE DONNÉES</h2>
          <p>Vos informations peuvent être transférées et stockées sur des serveurs situés en dehors du Gabon. En utilisant notre application, vous consentez à ce transfert. Nous nous assurons que des mesures de sécurité appropriées sont en place pour protéger vos données lors de ces transferts.</p>
        </section>

        <section>
          <h2>11. MODIFICATIONS DE CETTE POLITIQUE</h2>
          <p>Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Nous vous informerons de tout changement en publiant la nouvelle politique de confidentialité sur cette page et en mettant à jour la date de "Dernière mise à jour" en haut de ce document.</p>
          <p>Nous vous encourageons à consulter régulièrement cette politique de confidentialité pour rester informé de la manière dont nous protégeons vos informations.</p>
          <p>Les modifications importantes seront communiquées par :</p>
          <ul>
            <li>Une notification dans l'application</li>
            <li>Un email (si vous avez fourni une adresse email)</li>
            <li>Un avis sur notre site web (si applicable)</li>
          </ul>
        </section>

        <section>
          <h2>12. CONSERVATION DES DONNÉES</h2>
          <p>Nous conservons vos informations personnelles aussi longtemps que nécessaire pour :</p>
          <ul>
            <li>Fournir nos services</li>
            <li>Respecter nos obligations légales</li>
            <li>Résoudre les litiges</li>
            <li>Faire respecter nos accords</li>
          </ul>
          <p>Lorsque nous n'avons plus besoin de vos informations personnelles, nous les supprimerons ou les anonymiserons de manière sécurisée, sauf si la loi nous oblige à les conserver plus longtemps.</p>
        </section>

        <section>
          <h2>13. LIENS VERS DES SITES TIERS</h2>
          <p>Notre application peut contenir des liens vers des sites web ou des applications tiers. Nous ne sommes pas responsables des pratiques de confidentialité de ces sites tiers. Nous vous encourageons à lire les politiques de confidentialité de tout site ou application tiers que vous visitez.</p>
        </section>

        <section>
          <h2>14. NOTIFICATIONS WHATSAPP</h2>
          <p>Si vous avez activé les notifications WhatsApp, nous utilisons le service Whapi pour vous envoyer des notifications concernant vos commandes. Ces notifications sont envoyées uniquement pour vous informer de l'état de vos livraisons. Vous pouvez désactiver ces notifications à tout moment via les paramètres de l'application.</p>
        </section>

        <section>
          <h2>15. CONTACT</h2>
          <p>Si vous avez des questions, préoccupations ou demandes concernant cette politique de confidentialité ou nos pratiques en matière de données, veuillez nous contacter :</p>
          
          <div className="contact-info">
            <p><strong>Smart Delivery Gabon</strong></p>
            <p><strong>Email :</strong> <a href="mailto:smartdeliverygabon@gmail.com">smartdeliverygabon@gmail.com</a></p>
            <p><strong>Téléphone :</strong> <a href="tel:+241077773627">077773627</a></p>
            <p><strong>Adresse :</strong> Gabon</p>
            <p><strong>Site web :</strong> <a href="https://www.smartdeliverygabon.com" target="_blank" rel="noopener noreferrer">https://www.smartdeliverygabon.com</a></p>
          </div>
          
          <p>Nous nous engageons à répondre à vos demandes dans un délai raisonnable et conformément à la législation applicable en matière de protection des données.</p>
        </section>

        <section>
          <h2>16. LOI APPLICABLE</h2>
          <p>Cette politique de confidentialité est régie par les lois de la République Gabonaise. Tout litige découlant de cette politique sera soumis à la juridiction exclusive des tribunaux compétents du Gabon.</p>
        </section>

        <section>
          <h2>17. CONSENTEMENT</h2>
          <p>En utilisant l'application Smart Delivery Gabon, vous reconnaissez avoir lu, compris et accepté cette politique de confidentialité. Si vous n'acceptez pas cette politique, veuillez ne pas utiliser notre application.</p>
        </section>

        <div className="footer-note">
          <p><strong>Date d'entrée en vigueur :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          <p><strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          <p style={{ marginTop: '20px', fontStyle: 'italic' }}>
            Cette politique de confidentialité a été rédigée pour Smart Delivery Gabon et est conforme aux exigences de Google Play Console et aux lois applicables en matière de protection des données.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;

